export const bundleLimitTypes = {
  SPOT_RADIUS: 'SPOT_RADIUS',
  ACTIVE_GAMES: 'ACTIVE_GAMES',
  GAME_CHARACTERS: 'GAME_CHARACTERS',
  QUESTION_TYPES: 'QUESTION_TYPES',
  GAMES_PER_MONTH: 'GAMES_PER_MONTH',
  GAMERS_PER_GAME: 'GAMERS_PER_GAME',
} as const;
